import type { ServerError } from "@apollo/client";
import type { ErrorResponse } from "@apollo/client/link/error";
import { onError } from "@apollo/client/link/error";

const isServerError = (networkError: ErrorResponse["networkError"]): networkError is ServerError => {
  // eslint-disable-next-line no-prototype-builtins
  return networkError?.hasOwnProperty("statusCode") ?? false;
};

export const loginRedirectLink = onError(({ networkError, forward, operation }) => {
  if (isServerError(networkError) && networkError?.statusCode === 401) {
    if (window.location.pathname !== "/login") window.location.assign(`/login?target=${window.location.href}`);
  }
  return forward(operation);
});
